<template>
	<AppLayout
		:title="rotation.college.name"
		:subtitle="subtitle"
		:return-url="returnUrl ?? route('association.representatives.rotations.index')"
		:return-label="returnLabel ?? trans('menu.association.representatives.rotations')"
	>
		<template #actions>
			<slot name="actions"/>
		</template>
		<slot/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'

defineProps<{
	subtitle:string,
	rotation:Rotation,
	returnUrl?:string,
	returnLabel?:string,
}>()
</script>